import { useFetchDefectReportApi } from 'api/mypage/defect_report';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { useEffectSkipFirst } from 'utils/hooks';

type DefectReportShowProps = {};

export const DefectReportShow: React.FC = () => {
  const globalState = useContext(GlobalStateContext);
  const navigate = useNavigate();

  const defectReportApi = useFetchDefectReportApi();
  const { id } = useParams<{ id: string }>();
  const defectReportId = Number(id);

  useEffect(() => {
    defectReportApi.execute(defectReportId);
  }, []);

  useEffectSkipFirst(() => {
    globalState.setLoading(defectReportApi.loading);
    if (defectReportApi.isSuccess() && defectReportApi.response.defectReport.repairInfoId) {
      navigate(MypageRouteHelper.repairInfoShow(defectReportApi.response.defectReport.repairInfoId));
    }
  }, [defectReportApi.loading]);

  return <></>;
};

export default DefectReportShow;
